import React, { FC } from 'react';
import { ModalManager, ModalRouteProps } from 'context/ModalRouter';
import MovePostsPreselectedPosts from 'app/modules/posts/modules/movePosts/components/MovePostsPreselectedPosts';
import MovePostsWithPostsSelection from 'app/modules/posts/modules/movePosts/components/MovePostsWithPostsSelection';
import Modal from 'components/shared/Modal';
import { ActivityIndicator } from '@kontentino/ui';
import { ListPost } from 'types/PostDetail';
import { Project } from 'types/Page';

type Props = {
  modalManager: ModalManager;
  initialPosts: ListPost[];
  initialProjects?: Record<string, Project[]>;
  isLoading?: boolean;
} & ModalRouteProps;

const MovePostsModal: FC<Props> = ({
  modalManager,
  initialPosts,
  isLoading,
  initialProjects,
  ...props
}) => {
  return (
    <Modal
      size="md"
      modalManager={modalManager}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && (
        <div className="tw-flex tw-h-full  tw-w-full tw-justify-center tw-p-4">
          <ActivityIndicator className="tw-h-24  tw-w-24 tw-shrink-0" />
        </div>
      )}

      {!isLoading && (
        <>
          {initialPosts.length ? (
            <MovePostsPreselectedPosts
              initialProjects={initialProjects}
              initialPosts={initialPosts}
              onFinish={modalManager.close}
            />
          ) : (
            <MovePostsWithPostsSelection
              initialProjects={initialProjects}
              onFinish={modalManager.close}
            />
          )}
        </>
      )}
    </Modal>
  );
};

export default MovePostsModal;
